import * as React from 'react';
const SvgAiCross = (props) => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M63.757 0 0 63.764l15.912 15.914L79.67 15.914 63.757 0Z" fill={props.color} />
    <path d="M79.674 63.768 15.917.005.005 15.919l63.756 63.763 15.913-15.914Z" fill={props.color}/>
  </svg>
);
export default SvgAiCross;
